<template>
<div>

  <avue-crud
    :option="option"
    :data="data"
    :page.sync="page"
    :permission="permissionList"
    :before-open="beforeOpen"
    v-model="form"
    ref="crud"
    @row-del="rowDel"
    @search-change="searchChange"
    @search-reset="searchReset"
    @selection-change="selectionChange"
    @current-change="currentChange"
    @size-change="sizeChange"
    @refresh-change="onLoad"
    @on-load="onLoad"
  >
  </avue-crud>
    <el-dialog :visible.sync="viewShow" width="80%" :before-close="handleClose" append-to-body>
      <ViewKnowledge v-if="viewShow" :data="currentRow" />
    </el-dialog>
</div>

</template>

<script>
import {getKnowledgeGroupFileRecommendPage} from '@/api/crmedical/knowledge/group'
import ViewKnowledge from './view';

export default {
  components:{ViewKnowledge},
  data() {
    return {
      projectList: [],
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: false,
        searchMenuSpan: 6,
        border: true,
        index: true,
        addBtn: false,
        refreshBtn:false,
        columnBtn:false,
        searchIcon:false,
        viewBtn: true,
        editBtnText:'采用',
        delBtnText:'不采用',
        selection: false,
        column: [
          {
            label: '文件标题',
            prop: 'knowledgeNo',
          },
          {
            label: '文件类型',
            prop: 'knowledgeTitle',
          },
          {
            label: '文件说明',
            prop: 'knowledgeTitle',
          },
          {
            label: '推荐医院',
            prop: 'knowledgeTitle',
          },
          {
            label: '推荐人',
            prop: 'knowledgeTitle',
          },
          {
            label: '推荐原因',
            prop: 'knowledgeTitle',
          },
          {
            label: '推荐日期',
            prop: 'knowledgeTitle',
          },
        ],
      },
      data: [],
    };
  },
  methods:{
    beforeOpen(done,type){
      console.log('type==>',type);
      console.log('done==>',done);
    },
    rowDel(){
      console.log('del==>',);
    },
    sizeChange(){

    },
    currentChange(){

    },
    onload(){
      const params ={
        current:this.page.currentPage,
        size:this.page.pageSize,
      }
      getKnowledgeGroupFileRecommendPage(params).then(res=>{
        console.log('res getKnowledgeGroupFileRecommendPage==>',res);
        this.page.total  = res.data.total;
        this.data = res.data.records;
      })
    }
  },
  created(){
    this.onload()
  }
};
</script>